(function(endpointConfig) {
    'use strict';

    angular.module('GorillaBoy.services')
    .factory('EndpointConfig', ['$location', '$translate', 'AppConstants',
        function($location, $translate, AppConstants) {
            //DO NOT USE $log service inside this service as it causes circular dependency
            //on ClientMetricsService becuase $log is decorated with a function that uses ClientMetricService

            // AppConstant bindings
            var httpMethods = AppConstants.HttpMethods;

            var endPointConfigWrapper = {};

            // Private variables
            var stage = 'dev';
            var region = null;

            endPointConfigWrapper.LEGAL_PAGE_URL = 'https://amazonworkdocs.com/web-terms';
            endPointConfigWrapper.HELP_PAGE_URL = 'https://amazonworkdocs.com/web-help';
            endPointConfigWrapper.FORUM_PAGE_URL = "https://forums.aws.amazon.com/forum.jspa?forumID=172";

            endPointConfigWrapper.region = function() {
                return endpointConfig.getRegion();
            };

            endPointConfigWrapper.stage = function(region) {
                return endpointConfig.getStage(region);
            };

            endPointConfigWrapper.stageConfigKey = function(region) {
                return endpointConfig.getStageConfigKey(region);
            };

            endPointConfigWrapper.clientId = function() {
                return endpointConfig.getClientId(stage);
            };

            endPointConfigWrapper.organization = function() {
                return endpointConfig.getOrganization();
            };

            endPointConfigWrapper.oauth2RedirectUrl = function(stage) {
                return endpointConfig.getOauth2RedirectUrl(stage);
            };

            endPointConfigWrapper.oauth2RedirectUrlBasedOnUserPreference = function(stage){
                return endpointConfig.getOauth2RedirectUrlBasedOnUserPreference(stage);
            };

            endPointConfigWrapper.clientUrlDownload = function() {
                var preferredLanguage = $translate.proposedLanguage() || $translate.use(),
                    PROD_CLIENTS_URL = AppConstants.ClientDownloadUrl.ALL[preferredLanguage.toUpperCase()];
                return PROD_CLIENTS_URL;
            };

            endPointConfigWrapper.oauth2Endpoint = function() {
                return endpointConfig.getOauth2Endpoint(stage);
            };

            endPointConfigWrapper.loginV2Endpoint = function(stage) {
                return endpointConfig.getLoginV2Endpoint(stage);
            };

            endPointConfigWrapper.feedbackPageUrl = function() {
                return endpointConfig.getFeedbackUrl(stage);
            };

            endPointConfigWrapper.reportBugUrl = function() {
                return endpointConfig.getReportBugUrl(stage);
            };

            endPointConfigWrapper.isAmazonSite = function(){
                return endpointConfig.isAmazonSite(stage);
            };

            endPointConfigWrapper.logoClass = function(){
                return endpointConfig.getLogoClass(stage);
            };

            endPointConfigWrapper.endpoint = function(isNewAPI) {
                return endpointConfig.getServiceEndpoint(stage, isNewAPI);
            };

            endPointConfigWrapper.wopiEndpoint = function() {
                return endpointConfig.getWopiServiceEndpoint(stage);
            };

            endPointConfigWrapper.wdCollabServiceEndpoint = function() {
                return endpointConfig.getWdCollabServiceEndpoint(stage);
            };

            endPointConfigWrapper.hancomEndpoint = function() {
                return endpointConfig.getHancomEndpoint(stage);
            };

            endPointConfigWrapper.printContainerUrl = function() {
                return endpointConfig.getPrintContainerUrl(stage);
            };

            endPointConfigWrapper.clientEndpoint = function() {
                return endpointConfig.getField(stage, endpointConfig.CLIENT_ENDPOINT);
            };

            endPointConfigWrapper.webEndpoint = function() {
                return endpointConfig.getWebEndpoint(stage);
            };

            endPointConfigWrapper.appPrefix = function(stage) {
                return endpointConfig.getAppPrefix(stage);
            };

            endPointConfigWrapper.webEndpointPath = function() {
                // This path is constructed in two steps:
                // 1) Get the non-angularjs path
                // 2) Replace everything after the last trailing / with nothing
                return $location.absUrl().split('#')[0].replace(/[^/]+$/, "");
            };

            endPointConfigWrapper.isDevEnvironment = function() {

                var url = window.location && window.location.href;

                if (url) {
                    var prefixCount = endpointConfig.DEV_ENVIRONMENT_PREFIXES.length;

                    for(var i=0; i<prefixCount; i++) {
                        var prefix = endpointConfig.DEV_ENVIRONMENT_PREFIXES[i];

                        if (url.indexOf(prefix) === 0)
                            return true;
                    }
                }

                return false;
            };

            endPointConfigWrapper.isMetricsEnabled = function() {

                if (endPointConfigWrapper.isDevEnvironment()) {
                    return true;
                }

                var region = endPointConfigWrapper.region();

                if (region) {
                    if (endpointConfig.METRICS_REGION_WHITELIST && endpointConfig.METRICS_REGION_WHITELIST.indexOf(region) !== -1) {                        
                        return true;
                    }
                }

                return false;
            };

            endPointConfigWrapper.isPreviewSite = function(){
                return endpointConfig.isPreviewSite();
            };

            endPointConfigWrapper.isAllowedStage = function(){
                return endpointConfig.isAllowedStage();
            };

            // Initiate region and stage
            region = endPointConfigWrapper.region();
            stage = endPointConfigWrapper.stageConfigKey(region);
            return endPointConfigWrapper;
        }
    ])
    .factory('EndpointService', ['$http', '$location', '$route', 'EndpointConfig', 'MSIE', 'AppConstants',
        function($http, $location, $route, EndpointConfig, MSIE, AppConstants) {

            // AppConstant bindings
            var httpMethods = AppConstants.HttpMethods;

            var endpointService = {};

            /**

               The relationship between 'EndpointService' and 'EndpointConfig' is such that config gets initialized earlier
               in the application bootstrap lifecycle. All external modules use 'EndpointService' to identify various
               endpoints if the application is visited from 'awsapps.com' urls. Here is a log snippet of the relevant modules
               being intialized:

                   [SessionManager.js] Initializing Application angular.js:5765
                   [EndpointService.js] EndpointConfig - Initializing Application angular.js:5765
                   Region: us-east-1 angular.js:5765
                   Stage: alpha angular.js:5765
                   [EndpointService.js] EndpointService - Initializing Application angular.js:5765
                   sessionManager.getRegion: undefined angular.js:5765
                   [gorillaboy.js] Initializing Application angular.js:5765
                   endpoint: https://aws-gb-docs-alpha.amazon.com/gb/api/v1/ angular.js:5765
                   [routes.js] Initializing Application angular.js:5765
                   event.returnValue is deprecated. Please use the standard event.preventDefault() instead. jquery.min.js:3
                   [RegionService.js] Initializing Application angular.js:5765
                   Attempting to retrieving region information from cache angular.js:5765
                   sessionManager.getRegion: undefined angular.js:5765
                   Region information not available for non-'awsapps.com' domains angular.js:5765
                   oauth2CallbackEndpoint: https://DEVELOPER.desktop.amazon.com:8000/#/oauth2callback angular.js:5765
                   oauth2Endpoint: https://wormhole.us-east-1.amazonaws.com/ angular.js:5765
                   clientId: 52c3dfe68db8865f angular.js:5765

            */

            var CALLBACK_PATH = '/oauth2callback';

            endpointService.getClientEndpoint = function() {
                return EndpointConfig.clientEndpoint();
            };

            endpointService.clientId = function() {
                return EndpointConfig.clientId();
            };

            endpointService.stageConfigKey = function(region) {
                return EndpointConfig.stageConfigKey(region);
            };

            endpointService.oauth2Endpoint = function() {
                return EndpointConfig.oauth2Endpoint();
            };

            endpointService.loginV2Endpoint = function(stage) {
                return EndpointConfig.loginV2Endpoint(stage);
            };

            endpointService.oauth2RedirectUrl = function(stage) {
                return EndpointConfig.oauth2RedirectUrl(stage);
            };

            endpointService.oauth2RedirectUrlBasedOnUserPreference = function(stage){
                return EndpointConfig.oauth2RedirectUrlBasedOnUserPreference(stage);
            };

            endpointService.endpoint = function(isNewAPI) {
                return EndpointConfig.endpoint(isNewAPI);
            };

            endpointService.wopiEndpoint = function() {
                return EndpointConfig.wopiEndpoint();
            };

            endpointService.wdCollabServiceEndpoint = function() {
                return EndpointConfig.wdCollabServiceEndpoint();
            };

            endpointService.hancomEndpoint = function() {
                return EndpointConfig.hancomEndpoint();
            };

            endpointService.printContainerUrl = function() {
                return EndpointConfig.printContainerUrl();
            };

            endpointService.oauth2CallbackEndpoint = function() {
                return EndpointConfig.webEndpoint() + '#' + CALLBACK_PATH;
            };

            endpointService.isDevEnvironment = function() {
                return EndpointConfig.isDevEnvironment();
            };

            endpointService.isMetricsEnabled = function() {
                return EndpointConfig.isMetricsEnabled();
            };

            endpointService.isPreviewSite = function(){
                return EndpointConfig.isPreviewSite();
            };

            endpointService.isAllowedStage = function(){
                return EndpointConfig.isAllowedStage();
            };

            endpointService.organization = function() {
                return EndpointConfig.organization();
            };

            endpointService.appPrefix = function(stage) {
                return EndpointConfig.appPrefix(stage);
            };

            endpointService.loginV2ChangePasswordUrl = function(stage){
            	return EndpointConfig.loginV2Endpoint(stage).replace('checkAuth','changePassword');
            };

            endpointService.loginV2LogoutUrl = function(stage){
                return EndpointConfig.loginV2Endpoint(stage).replace('checkAuth','logout');
            };

            endpointService.tokenize = function(config) {
                if (!config.headers) {
                    config.headers = {};
                }
                // flXHR does not support PUT or DELETE, and only POST can use custom headers.
                // Fortunately, Coral respects the X-HTTP-Method-Override header, so everything
                // (even GETs) can be sent as POSTs.
                if (MSIE.VERSION() <= 9 && config.method !== httpMethods.POST) {
                    $.extend(config.headers, {
                        'X-HTTP-Method-Override': config.method
                    });
                    config.method = httpMethods.POST;
                    if (!config.data) {
                        config.data = {};
                    }
                }

                if (config.method === httpMethods.POST) {
                    $.extend(config.headers, {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    });
                }

                return config;
            };

            return endpointService;
        }
    ]);
}(_EndpointConfig));
